import { TCAppConfig } from "../../../../../shared/app-configs/tc-app-configs";

/**
 * Fetch product details using the given API caller.
 *
 * @param executeGet - The API call function from your custom hook.
 * @param tcId - The TE_ID or other identifier.
 * @param productId - The product identifier.
 * @returns A promise that resolves with the product details.
 * @throws An error if the fetch fails.
 */
export async function fetchProductaddDetails(
    executeGet: (url: string, params: Record<string, any>) => Promise<any>,
    tcId: string,
    productId: string,
    shipmentId:string
  ): Promise<any> {
    if (!productId) return null;
  
    try {
      const response = await executeGet(TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_NEW, {
        tcId,
        productId,
        shipmentId
      });
      return response;
    } catch (err) {
      console.error('Error fetching product details:', err);
      throw new Error('Failed to load product details.');
    }
  }
  
  